import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Link = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    height={height}
    width={width}
    viewBox="0 0 24 24"
    className="shape"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6692 3.00496C17.8206 2.95013 18.9471 3.35189 19.8039 4.12295C19.83 4.14642 19.8548 4.17126 19.8783 4.19735C20.6487 5.05429 21.05 6.18053 20.995 7.33154C20.9404 8.4751 20.4398 9.5514 19.6012 10.3299L18.4888 11.4422L17.4985 12.4592C17.1151 12.853 16.485 12.8614 16.0912 12.478C15.6974 12.0946 15.689 11.4645 16.0724 11.0707L17.0766 10.0394L18.2076 8.90849C18.2176 8.89857 18.2277 8.88886 18.238 8.87936C18.7006 8.45436 18.9769 7.86405 19.0068 7.2366C19.0359 6.62672 18.8301 6.0296 18.4329 5.56765C17.971 5.17015 17.3739 4.96408 16.7639 4.99312C16.1364 5.02301 15.546 5.29933 15.121 5.76206C15.1115 5.77246 15.1017 5.78265 15.0917 5.79262L13.9518 6.93252L12.9306 7.92801C12.5371 8.31171 11.907 8.30372 11.5233 7.91017C11.1396 7.51663 11.1476 6.88655 11.5411 6.50285L12.5577 5.5117L13.6702 4.3992C14.4487 3.56019 15.5254 3.05943 16.6692 3.00496ZM7.90984 11.5236C8.30339 11.9073 8.31136 12.5374 7.92765 12.9309L6.92338 13.9609L5.79233 15.0918C5.78241 15.1017 5.77228 15.1114 5.76195 15.1209C5.2993 15.546 5.02304 16.1364 4.99316 16.764C4.96411 17.3739 5.17009 17.9711 5.56744 18.433C6.02939 18.8302 6.62648 19.036 7.23633 19.0069C7.86379 18.9769 8.45411 18.7006 8.87912 18.2381C8.88861 18.2277 8.89833 18.2176 8.90825 18.2077L10.0486 17.0673L11.0704 16.0726C11.4642 15.6891 12.0943 15.6975 12.4777 16.0913C12.8612 16.4851 12.8528 17.1152 12.459 17.4986L11.442 18.4888L10.3296 19.6012C9.55116 20.4398 8.47485 20.9404 7.33127 20.995C6.18024 21.05 5.05398 20.6487 4.19703 19.8783C4.17087 19.8548 4.14598 19.8299 4.12245 19.8037C3.35171 18.9469 2.95014 17.8205 3.00496 16.6693C3.05942 15.5256 3.56001 14.4491 4.39879 13.6705L5.5114 12.5579L6.50249 11.5414C6.8862 11.1478 7.51629 11.1399 7.90984 11.5236Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M14.418 8.34324C14.7713 7.9938 15.341 7.99692 15.6904 8.35022C16.0399 8.70351 16.0367 9.2732 15.6834 9.62264L9.61436 15.6254C9.26106 15.9749 8.69137 15.9717 8.34192 15.6185C7.99247 15.2652 7.99559 14.6955 8.34889 14.346L14.418 8.34324Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
